<template>
  <div>
    <div class="container p-0">
      <hr class="mt-4 mb-1">
      <CountryRegionTrailsFilter/>
      <hr class="mb-4 mt-1">
    </div>
    <div class="container">
      <h2 class="mb-4 display-5">
        <strong>{{ title }}</strong>
        <i v-if="hasFilter" class="text-muted"> {{ $t('country_region_trails.filter_applied') }}</i>
      </h2>

      <div v-for="(hit, index) in hits" :key="hit.document.id">
        <a :href="`/hikes/${hit.document.country_slug}/${hit.document.region_slug}/${hit.document.trail_slug}`">
          <div class="row big-list">
            <div class="col-sm-1 d-none d-md-block p-0 position-relative">
              <span class="rubik-mono"><strong>{{index+1}}</strong></span>
            </div>
            <div class="col-12 col-sm-3 d-flex align-items-center justify-content-center">
              <img class="img-fluid rounded-lg w-100" :src="hit.document.static_map_url" alt="" width="239" height="120">
            </div>
            <div class="col-12 col-sm-8 my-2 d-flex align-items-center">
              <div>
                <p class="p-0 my-1">
                  <span class="badge mr-2" :class="hit.document.difficulty.toLowerCase()">
                    {{ hit.document.difficulty }}
                  </span>
                </p>
                <p class="display-5 m-0"><strong>{{ hit.document.name }}</strong></p>

                <p>
                  <span class="d-block d-md-inline text-muted" rel="noopener">
                    {{ hit.document.short_address }}
                  </span>
                  <span class="mx-1 d-none d-md-inline">&middot;</span>
                  {{ hit.document.average_rating }}
                  <small><span class="material-icons">star</span></small>
                  <span class="mx-1">&middot;</span>
                  <span>{{ $t('country_region_trails.number_of_ratings_reviews', { number_of_ratings: hit.document.number_of_ratings }) }}</span>
                  <span class="py-1">
                  </span>
                </p>
              </div>
            </div>
          </div>
        </a>
        <hr class="my-4">
      </div>
      <div class="row mb-4">
        <div class="col-12 col-md-4 mx-auto">
          <button class="btn btn-block btn-primary my-4" @click="moreClicked">{{ $t('shared.load_more') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import CountryRegionTrailsFilter from './components/CountryRegionTrailsFilter.vue';

export default defineComponent({
  components: {
    CountryRegionTrailsFilter,
  },
  computed: {
    hits() {
      if (this.typesenseResponse == null) {
        return [];
      }
      // eslint-disable-next-line max-len
      const trailCount = this.typesenseResponse.hits.length > this.$store.getters['countryRegionTrails/countToShow'] ? this.$store.getters['countryRegionTrails/countToShow'] : this.typesenseResponse.hits.length;
      return this.typesenseResponse.hits.slice(0, trailCount);
    },
    typesenseResponse() {
      return this.$store.state.countryRegionTrails.typesenseResponse;
    },
    countryName() {
      return window.countryName;
    },
    hasFilter() {
      return this.$store.getters['countryRegionTrails/hasFilter'];
    },
    title() {
      return this.$t('country_region_trails.best_hikes_in', { country: this.countryName });
    }
  },
  beforeCreate() {
    this.$store.dispatch('countryRegionTrails/initialiseStore');
  },
  methods: {
    moreClicked() {
      this.$store.commit('countryRegionTrails/incrementPageCount');
    },
  },
});
</script>
